import { type ApprovalDetails, NodeExecutionStatus } from "@doitintl/cmp-models";
import { type ModelTimestamp } from "@doitintl/models-any";
import { DateTime } from "luxon";

import { getTimeTaken } from "../utils";

export const formatCloudFlowRunDetailsTime = (time: ModelTimestamp | undefined) => {
  if (time?.toDate) {
    return DateTime.fromJSDate(time.toDate()).toLocaleString({
      ...DateTime.DATE_MED,
      ...DateTime.TIME_WITH_SECONDS,
    });
  }
  return "N/A";
};

export const calculateDuration = (
  status: NodeExecutionStatus,
  startTime?: ModelTimestamp,
  endTime?: ModelTimestamp
) => {
  if (status === NodeExecutionStatus.PENDING || status === NodeExecutionStatus.PENDING_APPROVAL) {
    return "Paused";
  }

  if (status === NodeExecutionStatus.IN_PROGRESS) {
    return "Ongoing";
  }

  if (!startTime || !endTime) {
    return "Invalid time";
  }

  return getTimeTaken(startTime, endTime);
};

export const createExecutionNodeDetails = (
  parameters: unknown[] | null | undefined,
  results: unknown[] | null | undefined,
  approvalDetails: ApprovalDetails | undefined
) => ({
  parameters: parameters ?? null,
  results: results ?? null,
  approvalDetails: approvalDetails ?? null,
});
